import { render, staticRenderFns } from "./Celebrations.vue?vue&type=template&id=2598854a&scoped=true"
import script from "./Celebrations.vue?vue&type=script&lang=js"
export * from "./Celebrations.vue?vue&type=script&lang=js"
import style0 from "./Celebrations.vue?vue&type=style&index=0&id=2598854a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2598854a",
  null
  
)

export default component.exports